import styled from 'styled-components';
import { Colors } from '@inplayer-org/inplayer-ui';
import { transparentize } from 'polished';
import { ifProp } from 'styled-tools';

interface TemplateSelectedProps {
  isTemplateSelected?: boolean;
}

export const PreviewBox = styled.div<TemplateSelectedProps>`
  text-decoration: none;
  border: 1px solid ${ifProp('isTemplateSelected', Colors.darkGray, Colors.gray)};
  border-top: 3px solid ${ifProp('isTemplateSelected', Colors.red, transparentize(0.7, Colors.skyBlue))};
  background: ${Colors.white};
  display: inline-block;
  width: 100%;
  vertical-align: top;
  padding: 8px 6.5%;
  box-sizing: border-box;
  color: ${Colors.fontDarkGray};
  position: relative;
  transition: all ease 200ms;
  cursor: pointer;

  &:hover {
    border: 1px solid ${Colors.darkGray};
    border-top: 3px solid ${Colors.red};
  }
`;

export const Image = styled.div<TemplateSelectedProps>`
  background: ${ifProp('isTemplateSelected', transparentize(0.6, Colors.red), transparentize(0.7, Colors.green))};
  height: 0;
  padding-bottom: 56%;
  width: 100%;
  margin: 5px auto 10px;
  transition: all ease 200ms;

  ${PreviewBox}:hover & {
    background: ${transparentize(0.6, Colors.red)};
  }
`;

export const Title = styled.div`
  background: ${transparentize(0.7, Colors.black)};
  height: 7px;
  width: 60%;
  margin: 7px 0;
`;

export const Button = styled.div<TemplateSelectedProps>`
  background: ${ifProp('isTemplateSelected', transparentize(0.3, Colors.red), transparentize(0.4, Colors.green))};
  height: 8px;
  width: 40%;
  margin: 5px 0;
  vertical-align: top;
  border-radius: 15px;
  border: 1px solid ${ifProp('isTemplateSelected', Colors.red, Colors.green)};
  transition: all ease 200ms;

  ${PreviewBox}:hover & {
    background: ${transparentize(0.3, Colors.red)};
    border: 1px solid ${Colors.red};
  }
`;

export const Description = styled.div`
  background: ${transparentize(0.8, Colors.black)};
  height: 4px;
  width: 100%;
  margin: 3px 0;
`;

export const ContentWrapper = styled.div`
  width: 48%;
  margin-left: 2%;
  vertical-align: middle;
  display: inline-block;
`;

export const Backing = styled.div`
  background: ${transparentize(0.8, Colors.black)};
  padding: 5px;
  margin: 2px;
  width: auto;
`;
